import { applyDesignSystemClasses } from '~/helpers/applyDesignSystemClasses';
import { useIntl } from '~/helpers/intl';
import { isTruthy } from '~/helpers/predicate';

export const SystemRequirements = ({
  requirements,
}: {
  requirements: (string | null)[];
}) => {
  const { t } = useIntl();

  if (!requirements || requirements.filter(Boolean).length === 0) return null;

  return (
    <div className="mt-6 xl:mt-8" data-testid="system-requirements-section">
      <h5 className="mb-1 webex-h3" data-testid="requirements-title">
        {t('pricing.systemRequirements.title', {
          fallback: 'System Requirements',
        })}
      </h5>

      {requirements
        .filter((s) => isTruthy(s))
        .map((requirement, key) => (
          <div
            key={key}
            dangerouslySetInnerHTML={{
              __html: applyDesignSystemClasses(requirement ?? ''),
            }}
          />
        ))}
    </div>
  );
};
